<template lang="pug">
  div
    visualizar-documentos(
      v-if="showModalVisualizaPdf",
      @closeModal="closeModalVisualizaPdf",
      :documentos="documentoSelecionado"
    )
    div(v-if="visualizarlabelTitulo")
      app-divider(:label="titulo", :tooltip="informacao", v-if="showDivider")
    el-row
      app-upload-documentos(
        :id="idUploadDocumento"
        v-model="documentoSelecionado"
        :target="urlUpload"
        :fileType="validExtensions"
        :tiposDocumentos="documentosFiltrados"
        :pecasTecnicas="pecasTecnicas"
        :maxSize="maxSize",
        :aba="aba",
        :required="tiposDocumentosObrigatorios && tiposDocumentosObrigatorios.length > 0 && isRequired",
        :documentos="documentos",
        :mensagemErroFilaPlantaMemorial="mensagemErroFilaPlantaMemorial",
        :isValidacaoPeloMenosUmDocumento="isValidacaoPeloMenosUmDocumento",
        @mudaTipo="mudaTipo",
        @anexar="anexar",
        @setDadosPlanilha="setDadosPlanilha"
        :mensagemOutros="mensagemOutros"
      )

    el-row
      validation-provider(:rules="requireDocumentosObrigatorios()" v-slot="{ errors }", :name="aba + '/Documentos'")
        .input(:class="{'erro box-error' : errors.length}")
          el-table(
            :data='documentos',
            v-model="validationValues"
          )
            div(slot='empty')
              span Nenhum arquivo adicionado. Para adicionar um novo arquivo, selecione-o e clique no botão "Anexar".
            el-table-column(
              prop='tipoDocumento.descricao',
              label='Tipo de documento:'
              align="left",
            )
            el-table-column(
              prop='fileName',
              label='Anexos'
            )
            el-table-column(
              label='Ações',
              align="center",
              width="100"
            )
              template(slot-scope='scope')
                app-action-button(
                  :disabled="!isDocumentoParaVisualizacao(scope.row)"
                  :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                  icone="eye",
                  :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                  fontSize="18",
                  @click="abrirDocumento(scope.row)"
                )
                app-action-button(
                  v-if="scope.row.id"
                  icone="download",
                  @click="getDownload(scope.row)",
                  cor="#666666",
                  text="Baixar Documento"
                )
                app-action-button(
                  icone="times",
                  @click="deleteRow(scope.row, scope.$index)",
                  cor="#CF0021",
                  text="Remover documento"
                )
        span.help.erro {{ errors[0] }}

</template>

<script>
import FileSaver from 'file-saver'
import AppActionButton from '@/components/AppActionButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppUploadDocumentos from '@/components/AppUploadDocumentos'
import _ from 'lodash'
import utils from '@/utils/utils'
import VisualizarDocumentos from '@/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue'
import axios from '@/utils/api'

const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppActionButton,
    AppUploadDocumentos,
    AppDivider,
    AppLabel,
    VisualizarDocumentos
  },

  data () {
    return {
      keyT: 0,
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      documentoSelecionado: null,
      isEstadoMA: process.env.ESTADO === 'ma',
      isEstadoBA: process.env.ESTADO === 'ba',
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  props: {
    titulo: {
      type: String,
      required: false,
      default: 'Documentação'
    },
    aba: {
      type: String,
      required: true
    },

    //! sempre necessário quando houver validação
    observer: {
      type: Object
    },

    documentos: {
      type: Array
    },

    tiposDocumentos: {
      type: Array,
      required: true
    },

    tiposDocumentosObrigatorios: {
      type: Array,
      required: false
    },

    validExtensions: {
      type: Array,
      required: true
    },

    maxSize: {
      type: Number,
      required: true
    },

    pecasTecnicas: {
      type: Boolean,
      default: false
    },

    pecasTecnicasSalvas: {
      type: Array
    },

    idUploadDocumento: {
      type: String,
      default: 'appUploadDocumento'
    },

    removeOutros: {
      type: Boolean,
      default: false
    },

    validateRule: {
      type: String,
      default: null
    },

    mensagemErroFilaPlantaMemorial: {
      type: String,
      default: ''
    },

    isOutraPessoa: {
      type: Boolean,
      required: false,
      default: false
    },

    isDocumentoImagex: {
      type: Boolean,
      required: false,
      default: false
    },

    isRequired: {
      type: Boolean,
      required: false,
      default: true
    },
    showDivider: {
      type: Boolean,
      default: true
    },
    mensagemOutros: {
      type: String,
      required: false
    },
    isValidacaoPeloMenosUmDocumento: {
      type: Boolean,
      required: false,
      default: false
    },
    visualizarlabelTitulo: {
      type: Boolean,
      required: false,
      default: true
    },
    pathDocumentosRemover: {
      type: Array,
      required: true
    }
  },

  computed: {

    informacao () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return 'Para esta análise nenhum documento é obrigatório,<br> mas é necessário anexar pelo menos um deles.'
      }

      if (this.tiposDocumentosObrigatorios && this.tiposDocumentosObrigatorios.length > 0) {
        const tiposObrigatorios = this.verificarObrigatoriedadeOutros.map(tipoDocumentoObrigatorio => tipoDocumentoObrigatorio.descricao)

        let infoTipoDocumentosObrigatorios = 'Documentos obrigatórios:'

        tiposObrigatorios.forEach(documento => { // eslint-disable-line
          infoTipoDocumentosObrigatorios += '<br> - '
          infoTipoDocumentosObrigatorios += documento
        })

        return infoTipoDocumentosObrigatorios
      }
      return ''
    },

    validationValues () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return { documentos: this.documentos, tiposDocumentos: this.tiposDocumentos }
      }
      return { documentos: this.documentos, documentosObrigatorios: this.documentosObrigatoriosFiltrados, isOutraPessoa: this.isOutraPessoa }
    },

    documentosFiltrados () {
      return _.uniqBy(this.tiposDocumentos, 'codigo')
    },

    documentosObrigatoriosFiltrados () {
      return _.uniqBy(this.verificarObrigatoriedadeOutros, 'codigo')
    },

    verificarObrigatoriedadeOutros () {
      return this.removeOutros ? this.tiposDocumentosObrigatorios.filter(t => t.tipo !== 'OUTROS' && t.tipo !== 'OUTROS_GEOMENSOR' && t.tipo !== 'OUTROS_FISCALIZADOR' && t.tipo !== 'OUTROS_VISTORIADOR' && t.tipo !== 'OUTROS_BENEFICIARIO' && t.tipo !== 'OUTROS_ADMINISTRATIVO') : this.tiposDocumentosObrigatorios
    }

  },

  methods: {
    ...mapActions({
      getDowloadDocument: 'download/downloadDocument'
    }),
    mudaTipo (opcao) {
      this.$emit('mudaTipo', opcao)
    },
    async getDownload (documento) {
      const file = await this.getDowloadDocument({...documento, key: documento.fileKey, id: null})
      FileSaver.saveAs(file, documento.fileName)
    },
    anexar (documento, invalidos) {
      this.documentos.push(documento)
    },

    deleteRow (row, index) {
      this.documentos.splice(index, 1)
      if (row.path) {
        this.pathDocumentosRemover.push(row.path)
      }
    },

    requireDocumentosObrigatorios () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return 'peloMenosUmDocumentoObrigatorio'
      }
      const validateRule = this.validateRule ? this.validateRule : 'documentosObrigatorios'
      return this.tiposDocumentosObrigatorios && this.isRequired ? validateRule : ''
    },

    setDadosPlanilha (valor) {
      this.$emit('setDadosPlanilha', valor)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    async getDocumento (documento) {
      if (documento.path) {
        return axios({
          method: 'POST',
          url: `documento/path`,
          data: { path: documento.path }
        })
      } else {
        return axios({
          method: 'GET',
          url: `documento/file/${documento.fileKey}`
        })
      }
    },
    async abrirDocumento (documento) {
      this.documentoSelecionado = [await this.getDocumento(documento)]
      this.showModalVisualizaPdf = true
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  },

  // Garante que a validação ocorra quando o componente fica inativo, devido ao keep-alive. (Equivalente ao beforeDestroy)
  async deactivated () {
    if (this.observer) {
      await this.observer.validate({
        skipIfEmpty: false,
        providerName: this.aba + '/Documentos'
      })
    }
  },

  watch: {
    documentos: {
      handler (val) {
        if (this.observer) {
          this.observer.validate({
            skipIfEmpty: false,
            providerName: this.aba + '/Documentos'
          })
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">

  .table {
    width: 100%;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  .label-info{
    margin-bottom: 20px;
    span {
      font-size: 12px;
    }
  }

  .el-alert {
    color: #047fa2 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppDocumentos.vue